import { Injectable } from '@angular/core';
import { PostmethodService } from '../../app-config/postmethod.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DetailsPanelService {

  constructor(private ws: PostmethodService) { }

  getDetails(leadId: string) {
    return this.ws.wsGet(environment.baseUrl + "/lead/getLead/" + leadId);
  }
  editDetails(request: any, id: any) {
    return this.ws.wsPut(request, environment.baseUrl + "/lead/tcUpdateLead", id);
  }
}
